
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { NB_AUTH_OPTIONS, getDeepFromObject } from '@nebular/auth';
import { AccountData } from '../../../@core/data/account.data';

@Component({
  selector: 'dpay-request-password-page',
  styleUrls: ['./request-password.component.scss'],
  templateUrl: './request-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestPasswordComponent {

  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  loading = false;

  constructor(protected service: AccountData,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected router: Router) {

    this.redirectDelay = this.getConfigValue('forms.requestPassword.redirectDelay');
    this.showMessages = this.getConfigValue('forms.requestPassword.showMessages');
    this.strategy = this.getConfigValue('forms.requestPassword.strategy');
  }

  requestPass(): void {
    this.messages = [];
    this.submitted = true;
    this.loading = true;
    this.service
      .resetPassword(this.user.email)
      .pipe()
      .subscribe({
        next: () => {
          this.messages.push("Solicitação enviada com sucesso. Verifique sua caixa de e-mail.")
          this.cd.detectChanges();
        },
        error: (failures: { error: { errorMessage: string; }[]; }) => {
          this.submitted = false;
          this.loading = false;
          this.errors = [];
          failures.error.forEach((err: { errorMessage: string; }) => {
            this.errors.push(err.errorMessage);
          });
          this.cd.detectChanges();
        }
      });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}
